const Language = {
  letters: [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ],
  symbols: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '=', '+', '_', '!', '#', '%', '(', ')'],
};

export default Language;
